var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47925 1.125C3.65184 1.125 3.79175 1.26491 3.79175 1.4375V8.80806L5.75828 6.84153C5.88032 6.71949 6.07818 6.71949 6.20022 6.84153C6.32226 6.96357 6.32226 7.16143 6.20022 7.28347L3.70022 9.78347C3.57818 9.90551 3.38032 9.90551 3.25828 9.78347L0.758277 7.28347C0.636238 7.16143 0.636238 6.96357 0.758277 6.84153C0.880316 6.71949 1.07818 6.71949 1.20022 6.84153L3.16675 8.80806V1.4375C3.16675 1.26491 3.30666 1.125 3.47925 1.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSortAsc);
export default __webpack_public_path__ + "static/media/table_sort_asc.cc220f28024b82b9355614a5824b8605.svg";
export { ForwardRef as ReactComponent };